'use client';

import { CustomSpin } from '@components/Common/CustomSpin';
import { setCookie } from '@utils/CookieUtil';
import { COOKIE_NAMES } from '@utils/constants';
import { getUTMs } from '@utils/utm';
import { useCommonAuthProvider, PromptOptions } from 'app/_modules/auth/providers/CommonAuthProvider/CommonAuthProvider';
import { useFlagsProxy } from 'app/_modules/feature-flags/hooks/useFlagsProxy';

import { RedirectLoginOptions } from '@auth0/auth0-spa-js';
import { Route } from 'next';
import { useRouter } from 'next/navigation';
import React, { FC, useEffect } from 'react';

export const Auth0: FC<RedirectLoginOptions> = (options) => {
  const router = useRouter();
  const { loginWithRedirect } = useCommonAuthProvider();
  const { serviceAuth0Available, cloudMspEnableUiFeatures } = useFlagsProxy();

  useEffect(() => {
    if (serviceAuth0Available === undefined) {
      return;
    }

    if (!serviceAuth0Available) {
      router.push('/login-unavailable' as Route);

      return;
    }

    const params = new URLSearchParams(window?.location?.search);
    const criblDocs = params.get('criblDocs');

    if (criblDocs) {
      setCookie(COOKIE_NAMES.CRIBL_DOCS, criblDocs);
    }

    const utms = getUTMs();
    const {
      authorizationParams,
      appState,
    } = options;
    loginWithRedirect({
      redirect_uri: authorizationParams?.redirect_uri,
      returnTo: appState?.returnTo,
      prompt: authorizationParams?.prompt as PromptOptions,
      connection: authorizationParams?.connection,
      organizationId: authorizationParams?.organizationId,
      customQueryParams: authorizationParams?.customQueryParams,
      utm: utms,
      ...(cloudMspEnableUiFeatures
        ? {
          screen_hint: authorizationParams?.screen_hint,
          loginHint: authorizationParams?.login_hint,
        }
        : {}
      ),
    });
  }, [serviceAuth0Available, options]);

  return <CustomSpin />;
};
